/** scopeKey кейса LEDGER_DIFFERENCE: `WALLET:{id}` */
export const parseWalletIdFromScopeKey = (scopeKey: string): number | null => {
  const match = /^WALLET:(\d+)$/.exec(scopeKey.trim());
  if (!match) return null;
  const id = Number.parseInt(match[1], 10);
  return Number.isSafeInteger(id) && id > 0 ? id : null;
};

export const isLedgerDifferenceCase = (type: string): boolean => type === 'LEDGER_DIFFERENCE';

/** Сумма для preview по правилам paygatex-back `adjustment()`. */
export const adjustmentAmountForMode = (caseAmount: string, mode: 'RESTORE_PROJECTION' | 'RECORD_MISSING_ENTRY'): string => {
  const trimmed = caseAmount.trim();
  if (mode === 'RECORD_MISSING_ENTRY') return trimmed;
  if (trimmed.startsWith('-')) return trimmed.slice(1) || '0';
  if (trimmed === '0') return '0';
  return `-${trimmed}`;
};
